import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "text-end" }

import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import ApiServices from '@/services/apiServices';
import { useLoaderState } from '@/store/loading';
import { error_message, success_message } from '@/components/common/toast';
import type { crawler } from '@/core/data/crawler';


export default /*@__PURE__*/_defineComponent({
  __name: 'CrawlerEdit',
  setup(__props) {

const CrawlerEdit = defineAsyncComponent(
    () => import('@/components/theme/crawler/CrawlerEdit.vue'),
);

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const crawler = ref<crawler>({
    id: '',
    name: '',
    source: '',
    sourceType: 1,
    message: '',
    status: 'CREATED',
    autoImport: false,
    defaultPageType: 4,
});

const title = computed(() =>
    crawler.value?.id
        ? t('crawlerEdit.updatetitle')
        : t('crawlerEdit.addtitle'),
);

const save = async () => {
    if (!crawler.value.name) {
        error_message(t('crawlerEdit.nameRequired'));
        return;
    }
    if (!crawler.value.source || !/^https?:\/\//i.test(crawler.value.source)) {
        error_message(t('crawlerEdit.sourceInvalid'));
        return;
    }
    useLoaderState().changeStateTrue();
    if (route.query.id) {
        ApiServices.update('crawlers', crawler.value, crawler.value.id)
            .then(() => {
                success_message(t('crawlerEdit.updated'));
                router.push({ name: 'crawlerList' });
            })
            .catch((ex: any) => error_message(ex.message))
            .finally(() => useLoaderState().changeStateFalse());
    } else {
        ApiServices.create('crawlers', crawler.value)
            .then(() => {
                success_message(t('crawlerEdit.saved'));
                router.push({ name: 'crawlerList' });
            })
            .catch((ex: any) => error_message(ex.message))
            .finally(() => useLoaderState().changeStateFalse());
    }
};

const getDatas = async () => {
    if (route.query.id) {
        ApiServices.getById('crawlers', route.query.id.toString()).then(
            (response: any) => {
                crawler.value = response;
            },
        );
    }
};

onMounted(() => {
    useLoaderState().changeStateTrue();
    getDatas();
    useLoaderState().changeStateFalse();
});

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_Card3 = _resolveComponent("Card3")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Aspirateur",
      mains: title.value,
      title: "Aspirateurs de site"
    }, null, 8, ["mains"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Card3, { colClass: "col-sm-12" }, {
          default: _withCtx(() => [
            _createVNode(_unref(CrawlerEdit), { crawler: crawler.value }, null, 8, ["crawler"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    class: "btn btn-success me-1",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (save()))
                  }, _toDisplayString(_ctx.$t('save')), 1)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})